import { gql } from "@apollo/client";

/** Backend creates Users-table row from Cognito claims when missing (new pool / failed PostConfirmation). */
export const ENSURE_MY_USER_RECORD = gql`
  mutation EnsureMyUserRecord {
    ensureMyUserRecord {
      id
      email
    }
  }
`;
